var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("div", {
    staticClass: "item-line"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("事件ID") + ":"))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(" " + _vm._s(_vm.insuranceInfoData["eventId"] || "-") + " ")])]), _c("div", {
    staticClass: "item-line"
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("客户名称") + ":"))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(" " + _vm._s(_vm.insuranceInfoData["customerName"] || "-") + " ")])])], 1), _c("div", {
    staticClass: "item-line"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("消息类别") + ":"))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.insuranceInfoData["messageCategoryName"]) || "-") + " ")])]), _c("div", {
    staticClass: "item-line"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("推送场景") + ":"))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.insuranceInfoData["pushScenarioName"]) || "-") + " ")])]), _c("div", {
    staticClass: "item-line"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("推送方式") + ":"))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(" " + _vm._s(_vm.pushMethod && _vm.pushMethod.replace("短信", _vm.$t("短信")).replace("站内信", _vm.$t("站内信")).replace("邮件", _vm.$t("邮件")) || "-") + " ")])]), _c("div", {
    staticClass: "item-line"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("处理状态") + ":"))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.mapStatus[_vm.insuranceInfoData["processingStatus"]]) || "-") + " ")])]), _vm.insuranceInfoData["processingStatus"] === "FAIL" ? _c("div", {
    staticClass: "item-line"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("失败原因") + ":"))]), _c("div", {
    staticClass: "right"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.insuranceInfoData["failureReason"]) || "-") + " ")])]) : _vm._e()]), _vm.btnGroup.length > 0 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("接收对象")))])]) : _vm._e(), _vm.btnGroup.length > 0 ? _c("div", [_c("a-radio-group", {
    attrs: {
      "button-style": "solid"
    },
    model: {
      value: _vm.tabValue,
      callback: function ($$v) {
        _vm.tabValue = $$v;
      },
      expression: "tabValue"
    }
  }, _vm._l(_vm.btnGroup, function (btnItem) {
    return _c("a-radio-button", {
      key: btnItem.value,
      staticClass: "marginR15 custom-style",
      attrs: {
        value: btnItem.value
      }
    }, [_vm._v(_vm._s(_vm.$t(btnItem.name)))]);
  }), 1), _c("div", {
    staticStyle: {
      padding: "0 50px"
    }
  }, [_c("div", {
    staticClass: "table-title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("模板") + "ID: "))]), _c("span", {
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_vm._v(_vm._s(_vm.dataSource[_vm.tabValue] && _vm.dataSource[_vm.tabValue].length > 0 ? _vm.dataSource[_vm.tabValue][0]["sceneConfigId"] : "-"))]), _vm.tabValue === "INTERNAL_MAIL" ? _c("span", [_vm._v(_vm._s(_vm.$t("阅读状态")) + " "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("已读人数") + "/" + _vm.$t("总接收人数")
    }
  }, [_c("a-icon", {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      type: "question-circle"
    }
  })], 1), _vm._v(" ：")], 1) : _vm._e(), _vm.tabValue === "INTERNAL_MAIL" ? _c("span", [_vm._v(_vm._s(_vm.readNumber))]) : _vm._e()]), _c("a-table", {
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.dataSource[_vm.tabValue],
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "customerName",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text ? text.replace("系统管理员", _vm.$t("系统管理员")).replace("全部", _vm.$t("全部")) : "-") + " ")];
      }
    }], null, false, 3408450698)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };